import React, { memo, useMemo } from 'react';
import { Box, Button, Container, Grid, Slide, Typography } from '@material-ui/core';
import { useObterSacola } from 'storage';
import { useStyles } from './button-sacola-styles';
import { CarrinhoIcon } from 'utils/Icons/carrinho-icon';
import { MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { useSacolaAbertaStore } from 'services/store/sacola-aberta';

export interface ButtonSacolaProps {
  empresaId: string;
  colorBadge: 'primary' | 'secondary';
  size?: string;
  produtoEntregaId: string | undefined;
}

export const ButtonSacola = memo(({
  empresaId,
  colorBadge,
  size,
  produtoEntregaId
}: ButtonSacolaProps) => {
  const sacola = useObterSacola(empresaId);
  const itens = useMemo(() => sacola?.data || [], [sacola?.data])
  const classes = useStyles();
  const abrirSacola = useSacolaAbertaStore().abrirSacola

  const totalItensPedido = useMemo(() => {
    let total =
      (itens).length > 0
        ? itens.filter(x => !x.idDoProdutoPaiInfoSubItem && produtoEntregaId !== x.produtoId)?.reduce((prev, next) => prev + (next?.qCom ?? 0), 0)
        : 0;

    return total || 0;
  }, [itens, produtoEntregaId]);

  const totalValorPedido = useMemo(() => {
    let total =
      (itens || ([] as MovSimplesProdutoModel[])).length > 0
        ? itens.filter(x => x.indFin).map((item) => {

          if (item.vUnCom === 0) {
            return 0;
          }
          return item.vUnCom * (item.qComModificador > 0 ? item.qComModificador : item.qCom) + item.vAcrescUsuario - item.vDescUsuario
        }).reduce((prev, next) => prev + next, 0)
        : 0;

    return (total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }, [itens]);

  return (
    <Slide direction="up" in={itens.length > 0} mountOnEnter unmountOnExit>
      <Box
        className={classes.root}
      >
        <Container fixed className={classes.container}>
          <Grid container alignItems='center'>
            <Grid item xs={4} sm={4} md={6}>
              <Typography className={classes.totalItens}>
                {totalItensPedido} {totalItensPedido === 1 ? 'item' : 'itens'}
              </Typography>
              <Typography className={classes.valorPedido}>
                {totalValorPedido}
              </Typography>
            </Grid>
            <Grid item xs md={6}>
              <Button color="primary" variant="contained" fullWidth onClick={abrirSacola}>
                <CarrinhoIcon tipo="BUTTON_PRIMARY" />
                Abrir Carrinho
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Slide>
  );
});

ButtonSacola.displayName = 'ButtonSacola';
